import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import CustomSearchDropdown from "../../Reports/components/FieldsComponent";
import "./ReviewQuestion.css";
import ReviewComponent from "./ReviewComponent";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchCourseData } from "./../../../Redux/StudentRegistration/courseSlice";
import { API_BASE_URL } from "../../../Config/Config";
import AddOptionDropdwon from "../ParseBulkQuestions/AddDropdownOptions";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import WarningImg from "./../../../Assets/Images/CommanImages/Warning.png";
import minusImgClose from "./../../../Assets/Images/CommanImages/MinusGrey.png";
import Success from "./../../../Assets/Images/CommanImages/success.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import DropDownUP from "../ParseBulkQuestions/Dropdown";
import DropDownUP2 from "../ParseBulkQuestions/DropdownUP2";
import DropDown from "./coursedrodpwonRQ";
import DropDownMN from "./DrodpwonRQDynamic";
import katex from "katex";
import "katex/dist/katex.min.css";
import pencil from "../../../Assets/Images/CommanImages/GPenz.png";
import UndoBack from "../../../Assets/Images/CommanImages/Reset.png";
import TestComponent from "./testReviewComponent";
import Colors from "../../../Constants/Colors";
import QuestionTypeRadio from "../../../Components/QuestionTypeRadio/QuestionTypeRadio";

import ToggleButtonIcon from "../../../Assets/Images/CommanImages/MinimizeMaximize.png";
const ReviewQuestion = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) => {
  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;

      // Store values in sessionStorage
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);
  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;

  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;

  const clearReviewData = () => {
    const keysToClear = ["POP", "NON", "TagsPOP", "ImagesPOP", "SKIPPOUT"];

    keysToClear.forEach((key) => {
      localStorage.removeItem(key);
    });

    // console.log(" Cleared local storage data on page load:", keysToClear);
  };

  // 🔹 Run when the page loads
  useEffect(() => {
    clearReviewData();
  }, []); // Empty dependency array → runs **only once** when the component mounts

  const questionContainerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);

    if (questionContainerRef.current) {
      questionContainerRef.current.style.display = isVisible ? "none" : "block";
    }
  };
  const [questionType, setQuestionType] = useState("Fill-In the Blanks");

  const [solutionHTML, setSolutionHTML] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [editedSolution, setEditedSolution] = useState("");
  const [editedVideoLink, setEditedVideoLink] = useState("");

  const [checkedTags, setCheckedTags] = useState({}); // State to store checkbox states
  const [refreshQuestions, setRefreshQuestions] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const setId = queryParams.get("setId");
  const setNameSet = queryParams.get("setName");
  const imageFiles = [];
  const { coursesdata = [] } = useSelector((state) => state.course);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [selectedCourseLabel, setSelectedCourseLabel] = useState("");
  const [selectedDifficultyLevelLabel, setSelectedDifficultyLevelLabel] =
    useState("");
  const [globalImageCounter, setGlobalImageCounter] = useState(0); // Global image counter
  const [selectedSetName, setSelectedSetName] = useState(null);
  const [selectedSetId, setSelectedSetId] = useState(setId); // Store selected ID
  const [setNames, setSetNames] = useState([]); // Dropdown options
  //  const  DeleteQuestion = useState(deletedQuestions);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [selected, setSelected] = useState([]);
  const [showTwoInputs, setShowTwoInputs] = useState(false);
  const toggleView = () => setShowTwoInputs(!showTwoInputs);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const { coursesdata } = useSelector((state) => state.course);
  const [isSectionVisible, setIsSectionVisible] = useState(true); // State to toggle visibility
  const [deletedQuestions, setDeletedQuestions] = useState([]);
  const [questionsData, setQuestionsData] = useState([]);
  const [isOpenTagging, setIsOpenTagging] = useState(true);
  const [isOpenUpload, setIsOpenUpload] = useState(true);
  // const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  // const [chapters, setChapters] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState(null);
  // const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [tags, setTags] = useState([]);
  const [dropdownData, setDropdownData] = useState({});
  const [value, setValues] = useState({ course_id: "" });
  const [uploadedFile, setUploadedFile] = useState(null);
  const [dropdownKey, setDropdownKey] = useState(Date.now());
  const [selectedSubjectLabel, setSelectedSubjectLabel] = useState(""); // Add this line
  const [selectedChapterLabel, setSelectedChapterLabel] = useState("");
  const [selectedTopicLabel, setSelectedTopicLabel] = useState("");
  const [topicId, setTopicId] = useState(null);
  const accessToken = localStorage.getItem("other");
  const toggleSectionVisibility = () => {
    setIsSectionVisible((prev) => !prev); // Toggle the visibility state
  };
  const [selectedPYQLabel, setSelectedPYQLabel] = useState(""); // For PYQ Dropdown
  const [selectedTestTagLabel, setSelectedTestTagLabel] = useState(""); // For Test Tag Dropdown
  const [selectedImportantLabel, setSelectedImportantLabel] = useState(""); // For Important Dropdown
  const [isSolutionExpanded, setIsSolutionExpanded] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [modalVideoContent, setModalVideoContent] = useState("");
  const handlePreviousButtonClick = () => {
    if (currentQuestion) {
      const currentIndex = questionsData.findIndex(
        (question) => question.question_id === currentQuestion.question_id
      );
      if (currentIndex > 0) {
        setCurrentQuestion(questionsData[currentIndex - 1]);
      }
    }
    setIsEditMode(false); // Ensure the mode is set to non-editable
    setShowTwoInputs(false); // Ensure edit inputs are hidden
  };

  const clearLocalStorage = () => {
    try {
      // Get all necessary data from localStorage
      const popData = JSON.parse(localStorage.getItem("POP")) || {};
      const nonData = JSON.parse(localStorage.getItem("NON")) || {};
      const tagsData = JSON.parse(localStorage.getItem("TagsMain")) || {};
      const allQuestions = { ...popData, ...nonData };

      // Format data in a more readable way
      const formattedData = {
        reviewSummary: {
          reviewDate: new Date().toLocaleString(),
          reviewedBy: userName,
          totalQuestions: Object.keys(allQuestions).length,
        },
        questions: [],
      };

      // Format each question's data
      Object.entries(allQuestions).forEach(([questionId, question]) => {
        const questionTags = tagsData[questionId] || [];

        // Format question data
        const formattedQuestion = {
          questionDetails: {
            id: questionId,
            number: question.parse_ques_set_ques_no,
            type: question.parse_ques_set_ques_type,
            status: getStatusText(question.status),
            reviewDate: new Date(question.initial_reviewed_on).toLocaleString(),
          },
          questionContent: question.question_text,
          options: question.options.map((opt, index) => ({
            optionNumber: index + 1,
            content: opt.option_text,
            isCorrect:
              opt.parse_ques_option_correct_flag === 1 ||
              opt.option_correct_flag === 1,
          })),
          tags: questionTags.map((tag) => ({
            tagName: tag.tag_name,
            value: tag.tag_value_id,
          })),
        };

        formattedData.questions.push(formattedQuestion);
      });

      // Create PDF
      const pdfContent = generatePDFContent(formattedData);
      const blob = new Blob([pdfContent], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Question_Review_Report_${
        new Date().toISOString().split("T")[0]
      }.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      // Clear localStorage
      const keysToClear = [
        "POP",
        "NON",
        "TagsPOP",
        "ImagesPOP",
        "DeletePush",
        "TagsMain",
      ];
      keysToClear.forEach((key) => localStorage.removeItem(key));

      // Show success message
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <p style={{ marginLeft: "20px", marginTop: "4px" }}>
              Cleared Faulty Values. Review report has been downloaded as PDF.
            </p>
          </div>
        </div>
      );
      setActiveImg(Success);
    } catch (error) {
      console.error("Error generating report:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error generating report. Please try again.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // Helper to map type id to label
  const getQuestionTypeLabel = (typeId) => {
    switch (typeId) {
      case 1:
        return "Single Select";
      case 2:
        return "Multi Select";
      case 3:
        return "Fill-In the Blanks";
      case 4:
        return "Boolean";
      default:
        return "";
    }
  };

  // Helper function to get status text
  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Not Reviewed";
      case 2:
        return "Reviewed";
      case 3:
        return "Deleted";
      case 4:
        return "Submitted";
      case 5:
        return "Permanently Deleted";
      case 6:
        return "Final Submission";
      default:
        return "Unknown";
    }
  };

  const generatePDFContent = (data) => {
    const { jsPDF } = require("jspdf");
    const doc = new jsPDF();
    const margin = 20;
    let yPos = margin;
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const contentWidth = pageWidth - 2 * margin;

    // Helper function to add new page
    const addNewPage = () => {
      doc.addPage();
      yPos = margin;
    };

    // Helper function to check and add new page if needed
    const checkNewPage = (neededSpace) => {
      if (yPos + neededSpace > pageHeight - margin) {
        addNewPage();
        return true;
      }
      return false;
    };

    // Helper function to write text with proper line breaks
    const writeText = (text, fontSize = 10, indent = 0) => {
      doc.setFontSize(fontSize);
      const lines = doc.splitTextToSize(text, contentWidth - indent);

      if (checkNewPage(lines.length * (fontSize / 2))) {
        // Reset yPos if new page was added
        yPos = margin;
      }

      doc.text(lines, margin + indent, yPos);
      yPos += lines.length * (fontSize / 2) + 5;
    };

    // Write Report Title
    doc.setFont("helvetica", "bold");
    writeText("Question Review Report", 16);
    yPos += 5;

    // Write Summary Section
    doc.setFont("helvetica", "normal");
    writeText(`Review Date: ${data.reviewSummary.reviewDate}`, 12);
    writeText(`Reviewed By: ${data.reviewSummary.reviewedBy}`, 12);
    writeText(`Total Questions: ${data.reviewSummary.totalQuestions}`, 12);
    yPos += 10;

    // Process each question
    data.questions.forEach((question, index) => {
      // Add section break
      doc.setDrawColor(200);
      doc.line(margin, yPos, pageWidth - margin, yPos);
      yPos += 10;

      // Question Header
      doc.setFont("helvetica", "bold");
      writeText(`Question ${question.questionDetails.number}`, 14);
      doc.setFont("helvetica", "normal");

      // Question Details
      writeText(`ID: ${question.questionDetails.id}`, 10);
      writeText(`Type: ${question.questionDetails.type}`, 10);
      writeText(`Status: ${question.questionDetails.status}`, 10);
      writeText(`Review Date: ${question.questionDetails.reviewDate}`, 10);
      yPos += 5;

      // Question Content
      doc.setFont("helvetica", "bold");
      writeText("Question Text:", 11);
      doc.setFont("helvetica", "normal");
      writeText(question.questionContent, 10, 10);
      yPos += 5;

      // Options
      doc.setFont("helvetica", "bold");
      writeText("Options:", 11);
      doc.setFont("helvetica", "normal");
      question.options.forEach((option, optIndex) => {
        const optionText = `${optIndex + 1}. ${option.content} ${
          option.isCorrect ? "[✓]" : "[ ]"
        }`;
        writeText(optionText, 10, 10);
      });
      yPos += 5;

      // Tags
      doc.setFont("helvetica", "bold");
      writeText("Tags:", 11);
      doc.setFont("helvetica", "normal");
      const tagText = question.tags
        .map((tag) => `${tag.tagName}: ${tag.value}`)
        .join(" | ");
      writeText(tagText, 10, 10);
      yPos += 10;
    });

    return doc.output();
  };

  // changed on 7/17/25
  // const handleImageClick = () => {
  //   setIsEditMode(!isEditMode);
  //   setCurrentQuestion(currentQuestion);
  //   toggleView();
  // };

  //new
  const handleImageClick = () => {
    setIsEditMode(!isEditMode);
    setCurrentQuestion(currentQuestion);
    setEditedSolution(currentQuestion?.explaination || "");
    setEditedVideoLink(currentQuestion?.video_url || "");
    toggleView();
  };

  useEffect(() => {
    // Initialize the counter based on existing images in localStorage
    const storedImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
    let maxCounter = 0;

    // Find the highest image number across all questions
    Object.values(storedImages).forEach((images) => {
      images.forEach((img) => {
        const match = img.name.match(/image(\d+)\.png/);
        if (match) {
          const number = parseInt(match[1], 10);
          if (number > maxCounter) maxCounter = number;
        }
      });
    });

    setGlobalImageCounter(maxCounter);
  }, []);

  useEffect(() => {
    if (selectedSetId) {
      const fetchQuestionsData = async () => {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parsed-questions-v2/?client_id=${clientId}&client_branch_id=${clientBranchId}&parse_ques_set_id=${selectedSetId}`,
            {
              method: "GET",
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("other")}`,
              },
            }
          );

          //  Ensure response is OK before parsing
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();

          //  Ensure data is an array before setting state
          if (Array.isArray(data) && data.length > 0) {
            setQuestionsData(data);

            const popData = JSON.parse(localStorage.getItem("POP")) || {};
            const nonData = JSON.parse(localStorage.getItem("NON")) || {};
            const firstQuestion = data[0];

            //  Check if first question exists in local storage
            if (popData[firstQuestion.question_id]) {
              setCurrentQuestion({
                ...firstQuestion,
                question_text: popData[firstQuestion.question_id].question_text,
                options: popData[firstQuestion.question_id].options,
              });
            } else if (nonData[firstQuestion.question_id]) {
              setCurrentQuestion({
                ...firstQuestion,
                question_text: nonData[firstQuestion.question_id].question_text,
                options: nonData[firstQuestion.question_id].options,
              });
            } else {
              setCurrentQuestion(firstQuestion);
            }
          } else {
            console.warn("No questions returned from API.");
            setQuestionsData([]); //  Ensure empty state is handled
            setCurrentQuestion(null); //  Reset current question
          }
        } catch (error) {
          console.error("Error fetching questions data:", error);
        }
      };

      fetchQuestionsData();
    }
  }, [selectedSetId, refreshQuestions]);

  // const handleLatexChange = (event) => {
  //   const newLatex = event.target.value;
  //   setConvertedHtml(katex.renderToString(newLatex, { throwOnError: false }));
  // };

  const handleButtonClick = (question) => {
    if (!isEditMode) {
      console.log("Navigating to question:", question.question_id);

      let loadedQuestion = question;

      setCurrentQuestion({
        ...question,
        question_text: loadedQuestion.question_text,
        options: loadedQuestion.options,
      });
    }
  };

  const processText = (text) => {
    if (!text) return "";

    // Decode HTML entities
    text = text
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&amp;/g, "&");

    // Convert <image .../> to <img ...>
    text = text.replace(
      /<image src="([^"]+)" alt="([^"]*)"(.*?)\/?>/g,
      '<img src="$1" alt="$2" style="max-width: 100px; max-height: 50px;" />'
    );

    text = text.replace(/([^\s]*?)imgsrc=([^\s]+)/g, (_, pre, url) => {
      const safePrefix = pre.trim() ? `${pre.trim()} ` : "";
      return `${safePrefix}<img src="${url}" class="Img-RQ-QnsAns" alt="image" />`;
    });

    // ✅ Support multiline LaTeX using dotAll mode (s)
    // Display math: \[...\]
    text = text.replace(/\\\[(.+?)\\\]/gs, (_, latex) =>
      katex.renderToString(latex, {
        throwOnError: false,
        displayMode: true,
      })
    );

    // Inline math: \(...\)
    text = text.replace(/\\\((.+?)\\\)/gs, (_, latex) =>
      katex.renderToString(latex, {
        throwOnError: false,
        displayMode: false,
      })
    );

    // Fix line breaks and paragraph spacing
    text = text
      .replace(/\n{2,}/g, "</p><p>") // 2+ newlines = new paragraph
      .replace(/\n/g, "<br/>"); // single newline = line break

    return `<p>${text}</p>`;
  };

  const [submittedQuestions, setSubmittedQuestions] = useState([]);
  const [reviewedQuestions, setReviewedQuestions] = useState([]);

  const getButtonClass = (question) => {
    let classes = [];
    const popData = JSON.parse(localStorage.getItem("POP")) || {}; //  Check stored reviewed questions in POP
    const nonData = JSON.parse(localStorage.getItem("NON")) || {}; //  Check stored reviewed questions in NON
    const reviewedData =
      JSON.parse(localStorage.getItem("reviewedQuestions")) || []; //  Local cache of reviewed questions

    if (
      popData[question.question_id] ||
      nonData[question.question_id] ||
      reviewedData.includes(question.question_id)
    ) {
      classes.push("blue-review-parser"); //  Always mark reviewed questions blue
    } else if (submittedQuestions.includes(question.question_id)) {
      classes.push("grey-submitted-parser");
    } else if (deletedQuestions.includes(question.question_id)) {
      classes.push("Delete_button_overlap_RQ");
    } else {
      switch (question.status) {
        case 4:
          classes.push("grey-submitted-parser");
          break;
        case 2:
          classes.push("blue-review-parser"); //  Ensure reviewed questions remain blue
          break;
        case 3:
          classes.push("Delete_button_overlap_RQ");
          break;
        case 5:
          classes.push("Delete_button_overlap_RQ-2");
          break;
        default:
          classes.push("White-Not-review-parser");
      }
    }

    if (currentQuestion?.question_id === question.question_id) {
      classes.push("current-question");
    }

    return classes.join(" ");
  };

  const handleSkipReview = () => {
    if (!currentQuestion) return;

    // Retrieve local storage data
    const skipOutData = JSON.parse(localStorage.getItem("SKIPPOUT")) || {};

    //  Store skipped question in SKIPPOUT
    skipOutData[currentQuestion.question_id] = {
      parse_ques_set_question_id: currentQuestion.question_id,
      parse_ques_set_id: selectedSetId,
      parse_ques_set_ques_no: currentQuestion.ques_no,
      parse_ques_set_ques_type: currentQuestion.ques_type,
      question_text: currentQuestion.question_text,
      status: 1, // Mark as "not reviewed"
      initial_reviewed_by: userName,
      initial_reviewed_on: new Date().toISOString(),
      options: currentQuestion.options.map((option, index) => ({
        parse_ques_set_option_id: option.option_id,
        parse_ques_set_id: selectedSetId,
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_option_no: option.option_no || index + 1,
        parse_ques_option_bool_type: option.option_bool_type,
        option_text: option.option_text,
        parse_ques_option_correct_flag: option.option_correct_flag,
        parse_ques_option_weightage: option.option_weightage,
      })),
    };

    //  Save the updated SKIPPOUT data
    localStorage.setItem("SKIPPOUT", JSON.stringify(skipOutData));

    console.log(
      ` Skipped review: Question ${currentQuestion.question_id} added to SKIPPOUT`
    );

    //  Ensure Status Change Triggers Button Color Update
    setQuestionsData((prevQuestions) => {
      const updatedQuestions = prevQuestions.map((q) =>
        q.question_id === currentQuestion.question_id
          ? { ...q, status: 1 } // Change status to 1 (not reviewed)
          : q
      );
      return [...updatedQuestions]; // Return a new array to trigger re-render
    });

    // Move to the next question
    const nextIndex =
      questionsData.findIndex(
        (q) => q.question_id === currentQuestion.question_id
      ) + 1;

    if (nextIndex < questionsData.length) {
      setCurrentQuestion(questionsData[nextIndex]);
    } else {
      console.log("No more questions left.");
    }

    // Reset UI states
    setIsEditMode(false);
    setShowTwoInputs(false);
  };

  const handleDeleteQuestion = () => {
    if (currentQuestion) {
      const deletePushData =
        JSON.parse(localStorage.getItem("DeletePush")) || {};

      if (deletedQuestions.includes(currentQuestion.question_id)) {
        // Restore question
        setDeletedQuestions(
          deletedQuestions.filter((id) => id !== currentQuestion.question_id)
        );
        delete deletePushData[currentQuestion.question_id]; // Remove from DeletePush
      } else {
        // Delete question
        setDeletedQuestions([...deletedQuestions, currentQuestion.question_id]);

        // Prepare question data for DeletePush
        const deletedQuestionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: currentQuestion.question_text,
          status: 3, // Default status for delete action
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: currentQuestion.options.map((option, index) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no || index + 1,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: option.option_text,
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
        };

        deletePushData[currentQuestion.question_id] = deletedQuestionData;
        localStorage.setItem("DeletePush", JSON.stringify(deletePushData));
        // Navigate to next question
        const currentIndex = questionsData.findIndex(
          (q) => q.question_id === currentQuestion.question_id
        );

        if (currentIndex === questionsData.length - 1) {
          // If it's the last question, go to the first question
          setCurrentQuestion(questionsData[0]);
        } else {
          // Otherwise, go to the next question
          setCurrentQuestion(questionsData[currentIndex + 1]);
        }

        // Reset UI states
        setIsEditMode(false);
        setShowTwoInputs(false);
      }
    }
  };

  useEffect(() => {
    dispatch(fetchCourseData());
    fetchTags();
  }, [dispatch]);

  useEffect(() => {
    const fetchSetNames = async () => {
      try {
        const token = sessionStorage.getItem("other");
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-ques-set-all/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          const formattedSetNames = data.data.map((item) => ({
            label: item.parse_ques_set_name,
            id: item.parse_ques_set_id,
          }));
          setSetNames(formattedSetNames);
        } else {
          console.error("Failed to fetch set names:", data.message);
        }
      } catch (error) {
        console.error("Error while fetching set names:", error);
      }
    };
    fetchSetNames();
  }, []);

  const fetchTags = async () => {
    try {
      const token = sessionStorage.getItem("other");
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-parse-tags-all/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        setTags(data.data);
      } else {
        console.error("Error fetching tags:", data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    const fetchSubjects = async () => {
      if (value.course_id) {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subjects-by-course/?course_id=${value.course_id}`
        );
        const data = await response.json();
        setSubjects(data);
        setSelectedSubjectLabel(""); // Reset the subject label
        setSelectedChapterLabel(""); // Reset the chapter label
        setSelectedTopicLabel(""); // Reset the topic label
        setTopicId(null); // Reset the topic ID
      }
    };

    fetchSubjects();
  }, [value.course_id]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (selectedSubject) {
        try {
          const response = await fetch(
            `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapters-by-subject/?subject_id=${selectedSubject}`
          );
          const chapterData = await response.json();
          setChapters(chapterData); // Update chapters list
          setSelectedChapterLabel(""); // Reset chapter label on subject change
          setSelectedChapter(null); // Clear chapter selection
          setTopics([]); // Clear topics when a new subject is selected
          setSelectedTopicLabel(""); // Reset topic label
          setTopicId(null); // Clear topic selection
        } catch (error) {
          console.error("Error fetching chapters:", error);
        }
      }
    };

    fetchChapters();
  }, [selectedSubject]); // Fetch chapters when selectedSubject changes

  useEffect(() => {
    if (selectedChapter) {
      fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-topics-by-chapter/?chapter_id=${selectedChapter}`
      )
        .then((response) => response.json())
        .then((topicData) => {
          setTopics(topicData);

          // Ensure that the topic value exists in the new chapter's topic list
          if (!topicData.some((topic) => topic.topic_id === topicId)) {
            setTopicId(null);
            setSelectedTopicLabel("Select Topic");
          }
        })
        .catch((error) => console.error("Error fetching topics:", error));
    }
  }, [selectedChapter]);

  const prepareTags = () => {
    const selectedTags = [];

    // Add parse_ques_set_id for all tags
    const parseQuesSetId = selectedSetId;

    console.log(" Preparing Tags...");

    // Process dropdown tags
    tags
      .filter((tag) => tag.parse_tag_type === 1)
      .forEach((tag) => {
        const selectedOption = dropdownData[tag.parse_tag_id]; // Get the selected option for this tag
        if (selectedOption) {
          selectedTags.push({
            parse_ques_set_id: parseQuesSetId, // Include selectedSetId
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: selectedOption,
          });
        }
      });

    // Process checkbox tags
    tags
      .filter((tag) => tag.parse_tag_type === 2)
      .forEach((tag) => {
        const checkbox = document.getElementById(
          `checkbox-${tag.parse_tag_id}`
        );
        if (checkbox) {
          selectedTags.push({
            parse_ques_set_id: parseQuesSetId, // Include selectedSetId
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_tag_id: tag.parse_tag_id,
            parse_ques_tag_value_id: checkbox.checked ? 1 : 0, // 1 if checked, 0 otherwise
          });
        }
      });

    if (value.course_id) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 2,
        parse_ques_tag_value_id: value.course_id,
      });
    }
    if (selectedSubject) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 3,
        parse_ques_tag_value_id: selectedSubject,
      });
    }
    if (selectedChapter) {
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId, // Include selectedSetId
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 4,
        parse_ques_tag_value_id: selectedChapter,
      });
    }

    if (selectedTopic) {
      console.log(" Topic is being saved:", selectedTopic);
      selectedTags.push({
        parse_ques_set_id: parseQuesSetId,
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: 5,
        parse_ques_tag_value_id: selectedTopic,
      });
    } else {
      console.warn(" Topic ID is null, not saving topic!");
    }

    return selectedTags;
  };

  const showErrorMessage = (message, fileName, content) => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{message}</span>
        </div>
        <div className="messagebox-insider2">
          {fileName && content && (
            <button
              className="messagebox-cancel-btn"
              onClick={() => downloadTxtFile(fileName, content)}
            >
              Download Error
            </button>
          )}
        </div>
      </div>
    );
    setActiveImg(ErrorImg);
  };

  const downloadTxtFile = (fileName, content) => {
    const blob = new Blob([content], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // function cleanImageSrcInText(text) {
  //   if (!text) return text;

  //   // First: Replace S3 URLs with local path (sans query params)
  //   text = text.replace(
  //     /imgsrc=(https:\/\/[^.]+\.s3(?:\.[^.]+)?\.amazonaws\.com\/([^\s'"?]+))/gi,
  //     (match, fullUrl, pathAndMaybeQuery) => {
  //       const localPath = pathAndMaybeQuery.split("?")[0];
  //       return `imgsrc=./${localPath}`;
  //     }
  //   );

  //   // Second: Remove any trailing ? and query from already-local imgsrc (./...)
  //   text = text.replace(
  //     /imgsrc=(\.[^\s'"]+)\?[^ \n\r'"]*/gi,
  //     (match, localPath) => `imgsrc=${localPath}`
  //   );

  //   return text;
  // }

  function cleanImageSrcInText(text) {
    if (!text) return text;

    // First: Handle <img> tags with S3 URLs - convert to imgsrc format
    text = text.replace(
      /<img\s+[^>]*src="(https:\/\/[^.\s]+\.s3(?:\.[^.\s]+)?\.amazonaws\.com\/([^?\s'"]+)(?:\?[^\s'">]*)?)"[^>]*>/gi,
      (match, fullUrl, pathPart) => {
        // Remove any query parameters that might be in pathPart
        const cleanPath = pathPart.split("?")[0];
        // Decode any URL encoded characters in the path
        const decodedPath = decodeURIComponent(cleanPath);
        // Change extension to .png regardless of original extension
        const pathWithPngExtension = decodedPath.replace(/\.[^.]+$/, ".png");
        return `imgsrc=./${pathWithPngExtension}`;
      }
    );

    // Second: Handle existing imgsrc= format with S3 URLs
    text = text.replace(
      /imgsrc=(https:\/\/[^.\s]+\.s3(?:\.[^.\s]+)?\.amazonaws\.com\/([^?\s'"]+)(?:\?[^\s'">]*)?)/gi,
      (match, fullUrl, pathPart) => {
        // Remove any query parameters that might be in pathPart
        const cleanPath = pathPart.split("?")[0];
        // Decode any URL encoded characters in the path
        const decodedPath = decodeURIComponent(cleanPath);
        // Change extension to .png regardless of original extension
        const pathWithPngExtension = decodedPath.replace(/\.[^.]+$/, ".png");
        return `imgsrc=./${pathWithPngExtension}`;
      }
    );

    // Third: Remove any trailing ? and query from already-local imgsrc (./...)
    text = text.replace(
      /imgsrc=(\.[^\s'"]+)\?[^\s'"<>]*/gi,
      (match, localPath) => `imgsrc=${localPath}`
    );

    // Fourth: Handle any remaining encoded characters in local paths and ensure .png extension
    text = text.replace(/imgsrc=\.\/([^?\s'"<>]+)/gi, (match, path) => {
      try {
        const decodedPath = decodeURIComponent(path);
        // Ensure .png extension
        const pathWithPngExtension = decodedPath.replace(/\.[^.]+$/, ".png");
        return `imgsrc=./${pathWithPngExtension}`;
      } catch (e) {
        // If decoding fails, still ensure .png extension
        const pathWithPngExtension = path.replace(/\.[^.]+$/, ".png");
        return `imgsrc=./${pathWithPngExtension}`;
      }
    });

    return text;
  }

  const handleUpdateQuestion = async (isSubmit = false) => {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Data is being sent, please wait...</span>
        </div>
      </div>
    );
    setActiveImg(Success);
    try {
      console.log("Starting update process...");

      // Load all required data from localStorage
      const popData = JSON.parse(localStorage.getItem("POP")) || {}; // Get edited questions
      const nonData = JSON.parse(localStorage.getItem("NON")) || {}; // Get unedited questions
      const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || []; // Get tagging data
      const imagesData = JSON.parse(localStorage.getItem("ImagesPOP")) || {}; // Get images data
      const deletePushData =
        JSON.parse(localStorage.getItem("DeletePush")) || {}; // Get deleted questions
      const skipOutData = JSON.parse(localStorage.getItem("SKIPPOUT")) || {}; // Get skipped questions

      // Validate if we have any data to process
      if (
        !Object.keys(popData).length &&
        !Object.keys(nonData).length &&
        !Object.keys(skipOutData).length &&
        !Object.keys(deletePushData).length
      ) {
        console.error("No questions data found in localStorage.");
        showErrorMessage(
          "No questions data to update. Please review, delete, or skip some questions first."
        );
        return;
      }

      // Prepare API endpoint
      const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-parse-questions/?parse_ques_set_id=${selectedSetId}`;
      const formData = new FormData();
      formData.append("username", userName);

      // Combine all question data
      const mergedData = { ...nonData, ...popData };

      // const explanationVideoList = Object.entries(mergedData).map(
      //   ([questionId, q]) => ({
      //     parse_ques_set_question_id:
      //       q.parse_ques_set_question_id || q.question_id,
      //     explaination: replaceImagesWithPlaceholders(
      //       q.explaination || "",
      //       questionId
      //     ),
      //     video_url: q.video_url || "",
      //   })
      // );
      const explanationVideoList = Object.entries(mergedData).map(
        ([questionId, q]) => ({
          parse_ques_set_question_id:
            q.parse_ques_set_question_id || q.question_id,
          explaination: cleanImageSrcInText(
            replaceImagesWithPlaceholders(q.explaination || "", questionId)
          ), // ✅ Chain: First replaceImagesWithPlaceholders, then cleanImageSrcInText
          video_url: q.video_url || "",
        })
      );
      formData.append(
        "explanation_video_list",
        JSON.stringify(explanationVideoList)
      );
      // Update delete status based on submit flag
      Object.keys(deletePushData).forEach((questionId) => {
        deletePushData[questionId].status = isSubmit ? 5 : 3;
      });

      // Prepare questions list including deleted and skipped questions
      const quesList = [
        // Regular questions
        ...Object.keys(mergedData).map((questionId) => {
          const questionData = mergedData[questionId];

          return {
            parse_ques_set_question_id: questionId,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_ques_no: questionData.parse_ques_set_ques_no,
            parse_ques_set_ques_type: questionData.parse_ques_set_ques_type,
            // question_text: replaceImagesWithPlaceholders(
            //   questionData.question_text,
            //   questionId
            // ),
            question_text: cleanImageSrcInText(
              replaceImagesWithPlaceholders(
                questionData.question_text,
                questionId
              )
            ),
            status: questionData.status,
            initial_reviewed_by: userName,
            initial_reviewed_on: new Date().toISOString(),
          };
        }),
        // Deleted questions
        ...Object.values(deletePushData),
        // Skipped questions
        ...Object.keys(skipOutData).map((questionId) => ({
          parse_ques_set_question_id: questionId,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no:
            skipOutData[questionId].parse_ques_set_ques_no,
          parse_ques_set_ques_type:
            skipOutData[questionId].parse_ques_set_ques_type,
          question_text: skipOutData[questionId].question_text,
          status: 1,
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
        })),
      ];

      formData.append("ques_list", JSON.stringify(quesList));

      const optionsList = Object.keys(mergedData).flatMap((questionId) => {
        const questionData = mergedData[questionId];
        return questionData.options.map((option) => ({
          parse_ques_set_option_id:
            option.parse_ques_set_option_id || option.option_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: questionId,
          parse_ques_option_no: option.parse_ques_option_no || option.option_no,
          parse_ques_option_bool_type: option.parse_ques_option_bool_type || 0,
          // parse_ques_option_text: replaceImagesWithPlaceholders(
          //   option.option_text || "",
          //   questionId
          // ), // <-- The CHANGE is here
          parse_ques_option_text: cleanImageSrcInText(
            replaceImagesWithPlaceholders(option.option_text || "", questionId)
          ),
          parse_ques_option_correct_flag:
            option.parse_ques_option_correct_flag === 1 ? 1 : 0,
          parse_ques_option_weightage: option.parse_ques_option_weightage || 0,
        }));
      });

      formData.append(
        "parse_ques_set_options_list",
        JSON.stringify(optionsList)
      );
      formData.append("parse_ques_tagging_list", JSON.stringify(tagsData));

      // --- Image Handling ---
      // const imagesData = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
      let imageCount = 0;

      Object.values(imagesData).forEach((imageArr) => {
        if (!Array.isArray(imageArr)) return;
        imageArr.forEach((img) => {
          if (!img.src || !img.name) return;
          try {
            const arr = img.src.split(",");
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) u8arr[n] = bstr.charCodeAt(n);
            const blob = new Blob([u8arr], { type: mime });
            formData.append(
              "files",
              new File([blob], img.name, { type: mime })
            );
            imageCount++;
          } catch (err) {
            console.warn(`Could not convert image ${img.name}:`, err);
          }
        });
      });

      // If NO images found, append a dummy empty file for backend compatibility
      if (imageCount === 0) {
        formData.append(
          "files",
          new Blob([], { type: "application/octet-stream" }),
          "dummy.txt"
        );
      }

      // Make API request
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("other")}`,
        },
        body: formData,
      });

      // Handle response
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error updating questions:", errorData);
        setErrorCount((prevCount) => prevCount + 1);
        showErrorMessage("Error while updating questions. Please try again.");
        setActiveImg(ErrorImg);
      } else {
        // Success handling

        const data = await response.json();
        console.log(" Questions updated successfully.", data);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{data.message}</span>
            </div>
          </div>
        );
        setActiveImg(Success);
        // Clear localStorage
        localStorage.removeItem("POP");
        localStorage.removeItem("NON");
        localStorage.removeItem("TagsPOP");
        localStorage.removeItem("ImagesPOP");
        localStorage.removeItem("DeletePush");
        localStorage.removeItem("TagsMain");
        localStorage.removeItem("SKIPPOUT");

        // Wait for 2 seconds before navigating back
        setTimeout(() => {
          navigate(-2);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while updating questions:", error);
      setErrorCount((prevCount) => prevCount + 1);
      showErrorMessage(
        "Unexpected error occurred while updating questions. Try again."
      );
    }
  };

  const handleSubmitSelectedReview = async () => {
    try {
      const localStorageKeys = [
        "POP",
        "NON",
        "TagsPOP",
        "ImagesPOP",
        "SKIPPOUT",
      ];
      const hasUnsavedChanges = localStorageKeys.some((key) => {
        const data = JSON.parse(localStorage.getItem(key) || "{}");
        return Object.keys(data).length > 0;
      });
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please wait sending data ...</span>
          </div>
        </div>
      );
      setActiveImg(Success);

      if (hasUnsavedChanges) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Please click Save before submitting the review. Please click
                Save before submitting the review .
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }
      //  Filter only questions with status 2 or 3
      const quesList = questionsData
        .filter((question) => question.status === 2 || question.status === 3)
        .map((question) => ({
          parse_ques_set_question_id: question.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: question.ques_no,
          parse_ques_set_ques_type: question.ques_type,
          status: question.status === 2 ? 4 : 5, //  Change status: 2 → 4, 3 → 5
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
        }));

      if (quesList.length === 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>No reviewed questions found to submit. Please </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      //  Filter out `null` values from taggingList
      const taggingList = questionsData.flatMap((question) =>
        question.tags
          .filter((tag) => tag.tag_value_id !== null) // 🔥 Remove `null` tag values
          .map((tag) => ({
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: question.question_id,
            parse_ques_tag_id: tag.tag_id,
            parse_ques_tag_value_id: tag.tag_value_id,
          }))
      );

      //  Prepare parse_ques_set_options_list
      const optionsList = questionsData.flatMap((question) =>
        question.options.map((option) => ({
          parse_ques_set_option_id: option.option_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: question.question_id,
          parse_ques_option_no: option.option_no || 0,
          parse_ques_option_bool_type: option.option_bool_type || 0,
          parse_ques_option_correct_flag: option.option_correct_flag || 0,
          parse_ques_option_weightage: option.option_weightage || 1,
        }))
      );
      // Prepare explanation_video_list directly from questionsData (GET API response)
      const explanationVideoList = questionsData.map((q) => ({
        parse_ques_set_question_id: q.question_id,
        explaination: cleanImageSrcInText(q.explaination || ""),
        video_url: q.video_url || "",
      }));

      //  Prepare FormData for API request
      const formData = new FormData();
      formData.append("username", userName);
      formData.append("ques_list", JSON.stringify(quesList));
      formData.append(
        "parse_ques_set_options_list",
        JSON.stringify(optionsList)
      );
      formData.append("parse_ques_tagging_list", JSON.stringify(taggingList));

      // Add empty file blob to avoid backend errors
      formData.append(
        "files",
        new Blob([], { type: "application/octet-stream" }),
        ""
      );

      formData.append(
        "explanation_video_list",
        JSON.stringify(explanationVideoList)
      );
      const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/update-parse-questions/?parse_ques_set_id=${selectedSetId}`;

      //  Make the API request
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("other")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error submitting reviewed questions:", errorData);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Error while submitting reviewed questions. Please try again.
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
      } else {
        const data = await response.json();
        console.log(" Reviewed questions submitted successfully.", data);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{data.message}</span>
            </div>
          </div>
        );
        setActiveImg(Success);

        // Wait for 2 seconds before navigating back
        setTimeout(() => {
          navigate(-2);
        }, 2000);
      }
    } catch (error) {
      console.error("Error while submitting reviewed questions:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              An unexpected error occurred while submitting reviewed questions.
              Please try again.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  //   Which is more Reactive in nature You or Me ?  ans is this structure .
  // Helper function to convert base64 to Blob
  const base64ToBlob = (base64) => {
    const byteString = atob(base64.split(",")[1]);
    const mimeType = base64.split(",")[0].match(/:(.*?);/)[1];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  };

  const convertLatexToHTML = (latex) => {
    return latex.replace(/\\\((.*?)\\\)/g, (match, p1) => {
      try {
        return katex.renderToString(p1, { throwOnError: false });
      } catch (error) {
        console.error("Error converting LaTeX:", error);
        return latex; // Return raw LaTeX on error
      }
    });
  };

  const [NewDataCOA, setNewDataCOA] = useState({});

  const fetchNewUpdatedDataValues = (newDataChild) => {
    if (!newDataChild) {
      console.error("No new data provided.");
      return null;
    }

    if (currentQuestion) {
      console.log(":: Updated values from child ::", newDataChild);
      console.log(":: Current Question ID ::", currentQuestion.question_id);

      // 1. Gather images from question text and options (your existing approach)
      let images = Array.isArray(newDataChild.images)
        ? [...newDataChild.images]
        : [];

      // 2. Extract images from the solution/explaination and add to images
      if (newDataChild.solution_text || newDataChild.explaination) {
        const solutionHtml =
          newDataChild.solution_text || newDataChild.explaination;
        images = images.concat(extractImagesFromHtml(solutionHtml, "solution"));
      }

      const updatedData = {
        QuestionIDNewDataChild: currentQuestion.question_id,
        QuestionTextNewDataChild: newDataChild.question_text,
        OptionTextNewDataChild: newDataChild.options,
        SolutionTextNewDataChild: newDataChild.solution_text,
        // ImagesNewDataChild: newDataChild.images, // Include images in updated data
        ImagesNewDataChild: images,
      };

      setNewDataCOA(updatedData);

      // Save images to localStorage
      const existingImages =
        JSON.parse(localStorage.getItem("ImagesPOP")) || {};
      existingImages[currentQuestion.question_id] = images;
      // existingImages[currentQuestion.question_id] = newDataChild.images;
      localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

      console.log(":: Returning updated data ::", updatedData);
      return updatedData;
    } else {
      console.error("No current question available.");
      return null;
    }
  };

  const handleReviewAndProceed = () => {
    if (!currentQuestion) return;
    if (!value.course_id || !selectedSubject) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Course and Subject are required. Please select them before
              proceeding.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Only check for correct options when NOT in edit mode
    if (!isEditMode) {
      const hasCorrectOption = currentQuestion.options.some((option) => {
        // Check both possible flag names for correct options
        return (
          option.option_correct_flag === 1 ||
          option.parse_ques_option_correct_flag === 1
        );
      });

      if (!hasCorrectOption) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please select at least one correct option to proceed.</span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return; // Stop the function from proceeding
      }
    }

    try {
      // Load existing local storage data
      const popData = JSON.parse(localStorage.getItem("POP")) || {};
      const nonData = JSON.parse(localStorage.getItem("NON")) || {};
      const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || [];
      const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

      // Generate updated tags for tagging
      const updatedTags = prepareTags();
      let questionData;

      if (!isEditMode) {
        // Non-Edit Mode logic
        questionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: cleanImageSrcInText(currentQuestion.question_text),
          status: 2,
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: currentQuestion.options.map((option, index) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no || index + 1,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: cleanImageSrcInText(option.option_text),
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
          explaination: currentQuestion.explaination || "",
          video_url: currentQuestion.video_url || "",
        };

        // ✅ TRY-CATCH for localStorage write
        try {
          nonData[currentQuestion.question_id] = questionData;
          localStorage.setItem("NON", JSON.stringify(nonData));
        } catch (storageError) {
          if (storageError.name === "QuotaExceededError") {
            throw new Error("STORAGE_QUOTA_EXCEEDED");
          }
          throw storageError;
        }
      } else {
        // Edit Mode logic
        NewDataCOA.OptionTextNewDataChild.forEach((option) => {
          console.log(
            `Option No: ${option.option_no}, Correct Flag: ${option.option_correct_flag}`
          );
        });

        questionData = {
          parse_ques_set_question_id: currentQuestion.question_id,
          parse_ques_set_id: selectedSetId,
          parse_ques_set_ques_no: currentQuestion.ques_no,
          parse_ques_set_ques_type: currentQuestion.ques_type,
          question_text: NewDataCOA.QuestionTextNewDataChild,
          status: 2,
          initial_reviewed_by: userName,
          initial_reviewed_on: new Date().toISOString(),
          options: NewDataCOA.OptionTextNewDataChild.map((option) => ({
            parse_ques_set_option_id: option.option_id,
            parse_ques_set_id: selectedSetId,
            parse_ques_set_question_id: currentQuestion.question_id,
            parse_ques_option_no: option.option_no,
            parse_ques_option_bool_type: option.option_bool_type,
            option_text: option.option_text,
            parse_ques_option_correct_flag: option.option_correct_flag,
            parse_ques_option_weightage: option.option_weightage,
          })),
          explaination: editedSolution || currentQuestion.explaination,
          video_url: editedVideoLink,
        };

        // ✅ TRY-CATCH for localStorage write
        try {
          popData[currentQuestion.question_id] = questionData;
          localStorage.setItem("POP", JSON.stringify(popData));
        } catch (storageError) {
          if (storageError.name === "QuotaExceededError") {
            throw new Error("STORAGE_QUOTA_EXCEEDED");
          }
          throw storageError;
        }
      }

      // Update TagsMain
      tagsMainData[currentQuestion.question_id] = updatedTags.map((tag) => ({
        tag_id: tag.parse_ques_tag_id,
        tag_value_id: tag.parse_ques_tag_value_id,
        tag_name:
          tags.find((t) => t.parse_tag_id === tag.parse_ques_tag_id)
            ?.parse_tag_name || "Unknown",
      }));

      // ✅ TRY-CATCH for TagsMain
      try {
        localStorage.setItem("TagsMain", JSON.stringify(tagsMainData));
      } catch (storageError) {
        if (storageError.name === "QuotaExceededError") {
          throw new Error("STORAGE_QUOTA_EXCEEDED");
        }
        throw storageError;
      }

      // Update TagsPOP
      const filteredTagsData = tagsData.filter(
        (tag) => tag.parse_ques_set_question_id !== currentQuestion.question_id
      );
      const newTagsFormatted = updatedTags.map((tag) => ({
        parse_ques_set_id: selectedSetId,
        parse_ques_set_question_id: currentQuestion.question_id,
        parse_ques_tag_id: tag.parse_ques_tag_id,
        parse_ques_tag_value_id: tag.parse_ques_tag_value_id,
      }));

      // ✅ TRY-CATCH for TagsPOP
      try {
        localStorage.setItem(
          "TagsPOP",
          JSON.stringify([...filteredTagsData, ...newTagsFormatted])
        );
      } catch (storageError) {
        if (storageError.name === "QuotaExceededError") {
          throw new Error("STORAGE_QUOTA_EXCEEDED");
        }
        throw storageError;
      }

      console.log("Updated TagsPOP (New Structure):", newTagsFormatted);

      // Find the index of the next question
      const nextIndex =
        questionsData.findIndex(
          (q) => q.question_id === currentQuestion.question_id
        ) + 1;

      if (nextIndex < questionsData.length) {
        setCurrentQuestion(questionsData[nextIndex]);
      } else {
        console.log(
          "Last question reviewed. Redirecting to the first question..."
        );
        setCurrentQuestion(questionsData[0]);
      }

      // Reset UI states
      setShowTwoInputs(false);
      setIsEditMode(false);

      // Clear edited states after saving
      setEditedSolution("");
      setEditedVideoLink("");
    } catch (error) {
      // ✅ HANDLE STORAGE QUOTA EXCEEDED ERROR
      if (error.message === "STORAGE_QUOTA_EXCEEDED") {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                Storage Limit Exceeded The images you've added are too large for
                browser storage. **Solutions:**
                <br />• Reduce image size/quality before uploading
                <br />• Click **SAVE** to send data to server immediately
              </span>
            </div>
          </div>
        );
        setActiveImg(ErrorImg);
        return;
      }

      // Handle other errors
      console.error("Error in handleReviewAndProceed:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              An unexpected error occurred while processing the question. Please
              try again or contact support.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  // const handleReviewAndProceed = () => {
  //   if (!currentQuestion) return;
  //   if (!value.course_id || !selectedSubject) {
  //     setIsMessageBoxVisible(true);
  //     setMessageBox(
  //       <div className="Container-messageBOX">
  //         <div className="messagebox-insider1">
  //           <div className="loader-tc"></div>
  //           <span>
  //             Course and Subject are required. Please select them before
  //             proceeding.
  //           </span>
  //         </div>
  //       </div>
  //     );
  //     setActiveImg(ErrorImg);
  //     return; // Stop the function from proceeding
  //   }

  // const hasCorrectOption = currentQuestion.options.some((option) => {
  //   // Check both possible flag names for correct options
  //   return (
  //     option.option_correct_flag === 1 ||
  //     option.parse_ques_option_correct_flag === 1
  //   );
  // });

  // if (!hasCorrectOption) {
  //   setIsMessageBoxVisible(true);
  //   setMessageBox(
  //     <div className="Container-messageBOX">
  //       <div className="messagebox-insider1">
  //         <div className="loader-tc"></div>
  //         <span>Please select at least one correct option to proceed.</span>
  //       </div>
  //     </div>
  //   );
  //   setActiveImg(ErrorImg);
  //   return; // Stop the function from proceeding
  // }

  //   // Load existing local storage data
  //   const popData = JSON.parse(localStorage.getItem("POP")) || {};
  //   const nonData = JSON.parse(localStorage.getItem("NON")) || {};
  //   const tagsData = JSON.parse(localStorage.getItem("TagsPOP")) || [];
  //   const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};
  //   // Generate updated tags for tagging
  //   const updatedTags = prepareTags();

  //   let questionData;

  //   if (!isEditMode) {
  //     // Non-Edit Mode (Untouched Questions)
  //     // questionData = {
  //     //   parse_ques_set_question_id: currentQuestion.question_id,
  //     //   parse_ques_set_id: selectedSetId,
  //     //   parse_ques_set_ques_no: currentQuestion.ques_no,
  //     //   parse_ques_set_ques_type: currentQuestion.ques_type,
  //     //   question_text: currentQuestion.question_text, // Unedited question text
  //     //   status: 2, // Mark as reviewed
  //     //   initial_reviewed_by: userName,
  //     //   initial_reviewed_on: new Date().toISOString(),
  //     //   options: currentQuestion.options.map((option, index) => ({
  //     //     parse_ques_set_option_id: option.option_id,
  //     //     parse_ques_set_id: selectedSetId,
  //     //     parse_ques_set_question_id: currentQuestion.question_id,
  //     //     parse_ques_option_no: option.option_no || index + 1,
  //     //     parse_ques_option_bool_type: option.option_bool_type,
  //     //     option_text: option.option_text,
  //     //     parse_ques_option_correct_flag: option.option_correct_flag,
  //     //     parse_ques_option_weightage: option.option_weightage,
  //     //   })),
  //     //   //new solution and video link adding
  //     //   explaination: editedSolution || currentQuestion.explaination, // Use existing solution if not edited
  //     //   video_url: editedVideoLink || currentQuestion.video_url, // Use existing video link if
  //     // };

  //     questionData = {
  //       parse_ques_set_question_id: currentQuestion.question_id,
  //       parse_ques_set_id: selectedSetId,
  //       parse_ques_set_ques_no: currentQuestion.ques_no,
  //       parse_ques_set_ques_type: currentQuestion.ques_type,
  //       question_text: cleanImageSrcInText(currentQuestion.question_text), // CLEAN HERE
  //       status: 2, // Mark as reviewed
  //       initial_reviewed_by: userName,
  //       initial_reviewed_on: new Date().toISOString(),
  //       options: currentQuestion.options.map((option, index) => ({
  //         parse_ques_set_option_id: option.option_id,
  //         parse_ques_set_id: selectedSetId,
  //         parse_ques_set_question_id: currentQuestion.question_id,
  //         parse_ques_option_no: option.option_no || index + 1,
  //         parse_ques_option_bool_type: option.option_bool_type,
  //         option_text: cleanImageSrcInText(option.option_text), // CLEAN HERE
  //         parse_ques_option_correct_flag: option.option_correct_flag,
  //         parse_ques_option_weightage: option.option_weightage,
  //       })),
  //       //new solution and video link adding
  //       explaination: currentQuestion.explaination || "", // Use original, not edited
  //       video_url: currentQuestion.video_url || "", // Use original, not edited
  //     };

  //     nonData[currentQuestion.question_id] = questionData;
  //     localStorage.setItem("NON", JSON.stringify(nonData));
  //   } else {
  //     // Edit Mode (Edited Questions)
  //     NewDataCOA.OptionTextNewDataChild.forEach((option) => {
  //       console.log(
  //         `Option No: ${option.option_no}, Correct Flag: ${option.option_correct_flag}`
  //       );
  //     });

  //     questionData = {
  //       parse_ques_set_question_id: currentQuestion.question_id,
  //       parse_ques_set_id: selectedSetId,
  //       parse_ques_set_ques_no: currentQuestion.ques_no,
  //       parse_ques_set_ques_type: currentQuestion.ques_type,
  //       question_text: NewDataCOA.QuestionTextNewDataChild, // **Edited question text**
  //       status: 2,
  //       initial_reviewed_by: userName,
  //       initial_reviewed_on: new Date().toISOString(),
  //       options: NewDataCOA.OptionTextNewDataChild.map((option) => ({
  //         parse_ques_set_option_id: option.option_id,
  //         parse_ques_set_id: selectedSetId,
  //         parse_ques_set_question_id: currentQuestion.question_id,
  //         parse_ques_option_no: option.option_no, //  TAKEN DIRECTLY FROM NewDataCOA
  //         parse_ques_option_bool_type: option.option_bool_type,
  //         option_text: option.option_text,
  //         parse_ques_option_correct_flag: option.option_correct_flag, //  TAKEN DIRECTLY FROM NewDataCOA
  //         parse_ques_option_weightage: option.option_weightage,
  //       })),
  //       explaination: editedSolution || currentQuestion.explaination,
  //       video_url: editedVideoLink, // <-- Save edited video link
  //     };

  //     popData[currentQuestion.question_id] = questionData;
  //     localStorage.setItem("POP", JSON.stringify(popData));
  //   }

  //   //  Update `TagsMain`
  //   tagsMainData[currentQuestion.question_id] = updatedTags.map((tag) => ({
  //     tag_id: tag.parse_ques_tag_id,
  //     tag_value_id: tag.parse_ques_tag_value_id,
  //     tag_name:
  //       tags.find((t) => t.parse_tag_id === tag.parse_ques_tag_id)
  //         ?.parse_tag_name || "Unknown",
  //   }));
  //   localStorage.setItem("TagsMain", JSON.stringify(tagsMainData));

  //   //  Update `TagsPOP`
  //   const filteredTagsData = tagsData.filter(
  //     (tag) => tag.parse_ques_set_question_id !== currentQuestion.question_id
  //   );
  //   const newTagsFormatted = updatedTags.map((tag) => ({
  //     parse_ques_set_id: selectedSetId,
  //     parse_ques_set_question_id: currentQuestion.question_id,
  //     parse_ques_tag_id: tag.parse_ques_tag_id,
  //     parse_ques_tag_value_id: tag.parse_ques_tag_value_id,
  //   }));

  //   localStorage.setItem(
  //     "TagsPOP",
  //     JSON.stringify([...filteredTagsData, ...newTagsFormatted])
  //   );

  //   console.log(" Updated TagsPOP (New Structure):", newTagsFormatted);

  //   //  Find the index of the next question
  //   const nextIndex =
  //     questionsData.findIndex(
  //       (q) => q.question_id === currentQuestion.question_id
  //     ) + 1;

  //   if (nextIndex < questionsData.length) {
  //     setCurrentQuestion(questionsData[nextIndex]); // Move to next question
  //   } else {
  //     //  LAST QUESTION: Send user back to first question
  //     console.log(
  //       " Last question reviewed. Redirecting to the first question..."
  //     );
  //     setCurrentQuestion(questionsData[0]); // 🔄 Reset to first question
  //   }

  //   //  Reset UI states
  //   setShowTwoInputs(false);
  //   setIsEditMode(false);

  //   // Clear edited states after saving
  //   setEditedSolution("");
  //   setEditedVideoLink("");
  // };

  function extractImagesFromHtml(html, type = "solution") {
    const imgRegex = /<img\s+[^>]*src="([^"]+)"[^>]*alt="([^"]*)"?[^>]*>/g;
    let match,
      images = [];
    let counter = 1;
    while ((match = imgRegex.exec(html)) !== null) {
      const src = match[1];
      const alt = match[2] || `${type}_image_${counter}`;
      const placeholder = `#<${alt}>#`;
      images.push({ name: alt, src, placeholder });
      counter++;
    }
    return images;
  }

  const applyTagsToAll = () => {
    try {
      if (!currentQuestion) {
        console.error("No current question selected");
        return;
      }

      // Get current tags from the current question
      const currentTags = prepareTags();

      // Get existing storage data
      const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};
      const tagsPopData = JSON.parse(localStorage.getItem("TagsPOP")) || [];

      // Apply current question's tags to all questions
      questionsData.forEach((question) => {
        const questionId = question.question_id;

        // Update TagsMain directly
        tagsMainData[questionId] = currentTags.map((tag) => ({
          tag_id: tag.parse_ques_tag_id,
          tag_value_id: tag.parse_ques_tag_value_id,
          tag_name:
            tags.find((t) => t.parse_tag_id === tag.parse_ques_tag_id)
              ?.parse_tag_name || "Unknown",
        }));

        // Create formatted tags for TagsPOP
        const formattedTags = currentTags.map((tag) => ({
          parse_ques_set_id: selectedSetId,
          parse_ques_set_question_id: questionId,
          parse_ques_tag_id: tag.parse_ques_tag_id,
          parse_ques_tag_value_id: tag.parse_ques_tag_value_id,
        }));

        // Add to TagsPOP array
        tagsPopData.push(...formattedTags);
      });

      // Save updates to localStorage
      localStorage.setItem("TagsMain", JSON.stringify(tagsMainData));
      localStorage.setItem("TagsPOP", JSON.stringify(tagsPopData));

      // Update UI states
      const currentCheckedStates = {};
      tags
        .filter((tag) => tag.parse_tag_type === 2)
        .forEach((tag) => {
          currentCheckedStates[tag.parse_tag_id] =
            !!checkedTags[tag.parse_tag_id];
        });
      setCheckedTags(currentCheckedStates);

      // Show success message
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div
          className="Container-messageBOX"
          onMouseEnter={pauseTimer}
          onMouseLeave={resumeTimer}
        >
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            {/* <span>Tags applied to all questions successfully , Please continue reviewing questions </span> */}
            <span>
              Tags applied to all questions successfully , Please review the
              questions and click on save to save the changes.
            </span>
          </div>
        </div>
      );
      setActiveImg(InterogativeImg);

      // Force refresh of UI
      // setRefreshQuestions((prev) => !prev);
    } catch (error) {
      console.error("Error in applyTagsToAll:", error);
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error applying tags to all questions. Please try again.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
    }
  };

  const replaceImagesWithPlaceholders = (text, questionId) => {
    const imgRegex =
      /<img src="(data:image\/[^;]+;base64,[^"]+)"[^>]*alt="([^"]+)"[^>]*>/g; // Match all base64 images
    const images = [];
    let match;
    let counter = 1; // Initialize a counter for sequential naming

    // Replace base64 images with placeholders
    const updatedText = text.replace(imgRegex, (match, src, alt) => {
      const uniqueName = alt ? alt : `image_${counter}`; // Use alt attribute if available, else fallback to sequential naming
      const placeholder = `#<${uniqueName}>#`; // Placeholder format

      images.push({ name: uniqueName, base64: src, placeholder }); // Store mapping
      counter++; // Increment counter for the next image
      return placeholder; // Replace the <img> tag with the placeholder
    });

    // Save images with placeholders into localStorage
    const existingImages = JSON.parse(localStorage.getItem("ImagesPOP")) || {};
    existingImages[questionId] = images; // Save images mapped to the current question ID
    localStorage.setItem("ImagesPOP", JSON.stringify(existingImages));

    return updatedText; // Return the text with placeholders
  };

  ////////////////////////////////////////////////////////////////////////
  // Function to store question tags in localStorage
  const storeTagsInLocalStorage = (questions) => {
    if (!Array.isArray(questions) || questions.length === 0) {
      console.warn("⚠️ No questions data provided.");
      return;
    }

    // Initialize an empty object for storing tags per question_id
    const tagsMain = {};

    // Loop through each question and extract its tags
    questions.forEach((question) => {
      const { question_id, tags } = question;

      if (Array.isArray(tags) && tags.length > 0) {
        tagsMain[question_id] = tags.map((tag) => ({
          tag_id: tag.tag_id,
          tag_value_id: tag.tag_value_id,
          tag_name: tag.tag_name,
        }));
      }
    });

    // Save to localStorage
    localStorage.setItem("TagsMain", JSON.stringify(tagsMain));

    // console.log(" Tags stored successfully in localStorage:", tagsMain);
  };

  //  Run this function when the page loads
  useEffect(() => {
    storeTagsInLocalStorage(questionsData);
  }, [questionsData]); // Runs every time questionsData is updated

  const matchAndSetCourseDropdown = (
    currentQuestionId,
    coursesData,
    setSelectedCourseLabel,
    setValues
  ) => {
    // Retrieve stored tags from localStorage
    const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

    if (!tagsMain[currentQuestionId]) {
      console.warn(`No tags found for question ID: ${currentQuestionId}`);
      return;
    }

    // Find the Course tag
    const courseTag = tagsMain[currentQuestionId].find(
      (tag) => tag.tag_name === "Course"
    );

    if (!courseTag) {
      console.warn("No Course tag found for this question.");
      return;
    }

    // Match the tag_value_id with course_id in API response
    const matchedCourse = coursesData.find(
      (course) => course.course_id === courseTag.tag_value_id
    );

    if (matchedCourse) {
      // console.log("Matched Course:", matchedCourse);
      setSelectedCourseLabel(matchedCourse.course_description); // Set selected dropdown label
      setValues((prevValues) => ({
        ...prevValues,
        course_id: matchedCourse.course_id,
      })); // Update state
    } else {
      // console.warn(
      //   "No matching course found for tag_value_id:",
      //   courseTag.tag_value_id
      // );
    }
  };

  useEffect(() => {
    if (
      currentQuestion &&
      Array.isArray(coursesdata) &&
      coursesdata.length > 0
    ) {
      matchAndSetCourseDropdown(
        currentQuestion.question_id,
        coursesdata,
        setSelectedCourseLabel,
        setValues
      );
    }
  }, [currentQuestion, coursesdata]);

  const matchAndSetSubjectDropdown = (
    currentQuestionId,
    subjectsData,
    setSelectedSubjectLabel,
    setSelectedSubject
  ) => {
    // Retrieve stored tags from localStorage
    const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

    if (!tagsMain[currentQuestionId]) {
      console.warn(`No tags found for question ID: ${currentQuestionId}`);
      return;
    }

    // Find the "Subject" tag
    const subjectTag = tagsMain[currentQuestionId].find(
      (tag) => tag.tag_name === "Subject"
    );

    if (!subjectTag) {
      console.warn("No Subject tag found for this question.");
      return;
    }

    // Match the tag_value_id with subject_id in API response
    const matchedSubject = subjectsData.find(
      (subject) => subject.subject_id === subjectTag.tag_value_id
    );

    if (matchedSubject) {
      // console.log("Matched Subject:", matchedSubject);
      setSelectedSubjectLabel(matchedSubject.subject_name); // Set selected dropdown label
      setSelectedSubject(matchedSubject.subject_id); // Update state
    } else {
      console.warn(
        // "No matching subject found for tag_value_id:",
        subjectTag.tag_value_id
      );
    }
  };

  useEffect(() => {
    if (currentQuestion && subjects.length > 0) {
      matchAndSetSubjectDropdown(
        currentQuestion.question_id,
        subjects,
        setSelectedSubjectLabel,
        setSelectedSubject
      );
    }
    // }, [currentQuestion]);
  }, [currentQuestion, subjects]);

  // When currentQuestion changes, update questionType state
  useEffect(() => {
    if (currentQuestion) {
      // Prefer question_type from currentQuestion, fallback to tagsMain if needed
      let typeId = currentQuestion.ques_type;
      // If not present, try to get from tagsMain
      if (!typeId) {
        const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};
        const tagsForQuestion = tagsMainData[currentQuestion.question_id] || [];
        // If you store type as a tag, find it here (adjust tag_name as needed)
        const typeTag = tagsForQuestion.find(
          (tag) => tag.tag_name === "Question Type"
        );
        if (typeTag) {
          typeId = typeTag.tag_value_id;
        }
      }
      setQuestionType(getQuestionTypeLabel(typeId));
    }
  }, [currentQuestion]);

  const matchAndSetChapterDropdown = (
    currentQuestionId,
    chaptersData,
    setSelectedChapterLabel,
    setSelectedChapter
  ) => {
    // Retrieve stored tags from localStorage
    const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

    if (!tagsMain[currentQuestionId]) {
      console.warn(`No tags found for question ID: ${currentQuestionId}`);
      return;
    }

    // Find the Chapter tag
    const chapterTag = tagsMain[currentQuestionId].find(
      (tag) => tag.tag_name === "Chapter"
    );

    if (!chapterTag) {
      console.warn("No Chapter tag found for this question.");
      return;
    }

    // Match the tag_value_id with chapter_id in API response
    const matchedChapter = chaptersData.find(
      (chapter) => chapter.chapter_id === chapterTag.tag_value_id
    );

    if (matchedChapter) {
      // console.log("Matched Chapter:", matchedChapter);
      setSelectedChapterLabel(matchedChapter.chapter_desc); // Set selected dropdown label
      setSelectedChapter(matchedChapter.chapter_id); // Update selected chapter ID
    } else {
      console.warn(
        // "No matching chapter found for tag_value_id:",
        chapterTag.tag_value_id
      );
    }
  };

  useEffect(() => {
    if (currentQuestion && chapters.length > 0) {
      matchAndSetChapterDropdown(
        currentQuestion.question_id,
        chapters,
        setSelectedChapterLabel,
        setSelectedChapter
      );
    }
    // }, [currentQuestion]);
  }, [currentQuestion, chapters]); // Depend on currentQuestion and fetched chapters data

  const matchAndSetTopicDropdown = (
    currentQuestionId,
    topicsData,
    setSelectedTopicLabel,
    setTopicId
  ) => {
    // Retrieve stored tags from localStorage
    const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

    if (!tagsMain[currentQuestionId]) {
      console.warn(`No tags found for question ID: ${currentQuestionId}`);
      return;
    }

    // Find the Topic tag
    const topicTag = tagsMain[currentQuestionId].find(
      (tag) => tag.tag_name === "Topic"
    );

    if (!topicTag) {
      console.warn("No Topic tag found for this question.");
      return;
    }

    // Match the tag_value_id with topic_id in API response
    const matchedTopic = topicsData.find(
      (topic) => topic.topic_id === topicTag.tag_value_id
    );

    if (matchedTopic) {
      // console.log("Matched Topic:", matchedTopic);
      setSelectedTopicLabel(matchedTopic.topic_name); // Set selected dropdown label
      setTopicId(matchedTopic.topic_id); // Update selected topic ID
    } else {
      console.warn(
        "No matching topic found for tag_value_id:",
        topicTag.tag_value_id
      );
    }
  };

  useEffect(() => {
    if (currentQuestion) {
      const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

      if (tagsMainData[currentQuestion.question_id]) {
        const currentTags = tagsMainData[currentQuestion.question_id];

        const topicTag = currentTags.find((tag) => tag.tag_id === 5);
        if (topicTag) {
          // console.log("🟢 Loading Topic from TagsMain:", topicTag.tag_value_id);
          setTopicId(topicTag.tag_value_id);
          setSelectedTopicLabel(
            topics.find((top) => top.topic_id === topicTag.tag_value_id)
              ?.topic_name || "Select Topic"
          );
        } else {
          // console.warn("⚠️ No matching topic found in TagsMain");
        }
      }
    }
  }, [currentQuestion, topics]);

  useEffect(() => {
    if (currentQuestion && topics.length > 0) {
      matchAndSetTopicDropdown(
        currentQuestion.question_id,
        topics,
        setSelectedTopicLabel,
        setTopicId
      );
    }
    // }, [currentQuestion]); // Depend on currentQuestion and fetched topics data
  }, [currentQuestion, topics]); // Depend on currentQuestion and fetched topics data

  const matchAndSetDropdownTags = (
    currentQuestionId,
    tags, // API response
    setDropdownData,
    tagSetters // Object containing all available setters
  ) => {
    // Retrieve stored tags from localStorage
    const tagsMain = JSON.parse(localStorage.getItem("TagsMain")) || {};

    if (!tagsMain[currentQuestionId]) {
      // console.warn(`⚠️ No tags found for question ID: ${currentQuestionId}`);
      return;
    }

    // Iterate through tags dynamically
    tagsMain[currentQuestionId].forEach((storedTag) => {
      const tagName = storedTag.tag_name; // Extract dynamic tag name

      // Find the matching API tag
      const matchedTag = tags
        .find((tag) => tag.parse_tag_name === tagName)
        ?.parse_tag_value.find(
          (value) => value.parse_tag_value_id == storedTag.tag_value_id
        );

      if (matchedTag) {
        // console.log(` Matched '${tagName}':`, matchedTag);

        // Use setter dynamically (if exists)
        if (tagSetters[tagName]) {
          tagSetters[tagName](matchedTag.tag_value);
        }

        setDropdownData((prevData) => ({
          ...prevData,
          [tagName]: matchedTag.parse_tag_value_id, // Update dynamically
        }));
      } else {
        // console.warn(`⚠️ No matching '${tagName}' found for tag_value_id:`, storedTag.tag_value_id);
      }
    });
  };

  useEffect(() => {
    if (currentQuestion && tags.length > 0) {
      matchAndSetDropdownTags(
        currentQuestion.question_id,
        tags,
        setDropdownData,
        {
          [selectedDifficultyLevelLabel]: setSelectedDifficultyLevelLabel,
          [selectedPYQLabel]: setSelectedPYQLabel,
          [selectedTestTagLabel]: setSelectedTestTagLabel,
          [selectedImportantLabel]: setSelectedImportantLabel,
        }
      );
    }
  }, [currentQuestion, tags]); // Runs dynamically

  useEffect(() => {
    if (currentQuestion) {
      const tagsMainData = JSON.parse(localStorage.getItem("TagsMain")) || {};

      if (tagsMainData[currentQuestion.question_id]) {
        const currentTags = tagsMainData[currentQuestion.question_id];

        //  Dynamically match `parse_tag_id` (API) with `tag_id` (LocalStorage)
        const updatedDropdownData = {};
        const updatedCheckedTags = {};

        currentTags.forEach((tag) => {
          const matchingTag = tags.find((t) => t.parse_tag_id === tag.tag_id);
          if (matchingTag) {
            if (matchingTag.parse_tag_type === 1) {
              updatedDropdownData[tag.tag_id] = tag.tag_value_id;
            } else if (matchingTag.parse_tag_type === 2) {
              updatedCheckedTags[tag.tag_id] = tag.tag_value_id === 1;
            }
          }
        });

        //  Update State for Dropdowns
        setDropdownData((prev) => ({
          ...prev,
          ...updatedDropdownData,
        }));

        //  Update State for Checkboxes
        setCheckedTags(updatedCheckedTags);

        //  Update Course Dropdown
        const courseTag = currentTags.find((tag) => tag.tag_id === 2);
        if (courseTag) {
          setValues({ course_id: courseTag.tag_value_id });
          // setSelectedCourseLabel(
          //   coursesdata.find(
          //     (course) => course.course_id === courseTag.tag_value_id
          //   )?.course_description || "Select Course"
          // );
          setSelectedCourseLabel(
            Array.isArray(coursesdata)
              ? coursesdata.find(
                  (course) => course.course_id === courseTag.tag_value_id
                )?.course_description || "Select Course"
              : "Select Course"
          );
        }

        //  Update Subject Dropdown
        const subjectTag = currentTags.find((tag) => tag.tag_id === 3);
        if (subjectTag) {
          setSelectedSubject(subjectTag.tag_value_id);
          setSelectedSubjectLabel(
            subjects.find((sub) => sub.subject_id === subjectTag.tag_value_id)
              ?.subject_name || "Select Subject"
          );
        }

        //  Update Chapter Dropdown (Existing Logic)
        const chapterTag = currentTags.find((tag) => tag.tag_id === 4);
        if (chapterTag) {
          setSelectedChapter(chapterTag.tag_value_id);
          setSelectedChapterLabel(
            chapters.find((chap) => chap.chapter_id === chapterTag.tag_value_id)
              ?.chapter_name || "Select Chapter"
          );
        }

        //  Update Topic Dropdown (Now EXACTLY like Chapter Dropdown)
        const topicTag = currentTags.find((tag) => tag.tag_id === 5);
        if (topicTag) {
          setTopicId(topicTag.tag_value_id);
          setSelectedTopicLabel(
            topics.find((top) => top.topic_id === topicTag.tag_value_id)
              ?.topic_name || "Select Topic"
          );
        }
      }
    }
  }, [currentQuestion]);

  useEffect(() => {
    if (currentQuestion) {
      setSolutionHTML(currentQuestion?.explaination || "");
      setVideoLink(currentQuestion?.video_url || "");
      setIsSolutionExpanded(false); // Reset expansion for new question
    }
  }, [currentQuestion]);

  const checkStorageSpace = () => {
    try {
      const testKey = "storage-test";
      const testData = "x".repeat(1024 * 1024); // 1MB test
      localStorage.setItem(testKey, testData);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  };

  // Use before saving large data
  if (!checkStorageSpace()) {
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>
            **Storage space is running low!** Please click SAVE to send data to
            server before continuing.
          </span>
        </div>
      </div>
    );
    setActiveImg(WarningImg);
    return;
  }

  return (
    <>
      <div className="sticky-header-container">
        <div className="Header-up">
          <span className="span-RQ" style={{ marginLeft: "10px" }}>
            Review Question{" "}
            <span style={{ color: "lightgrey" }}>{/* / {setNameSet} */}</span>
          </span>
          <div style={{ marginRight: "30px" }}>
            {errorCount > 1 && (
              <button
                className="testreportcard-cancel-btn width-superseeding-2"
                onClick={clearLocalStorage}
                style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                Clear Faulty Data
              </button>
            )}
            <button
              className="testreportcard-cancel-btn"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>
            <button
              className="testreportcard-cancel-btn"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={() => handleUpdateQuestion(false)}
            >
              SAVE
            </button>
            <button
              className="testreportcard-create-btn width-superseeding-2"
              style={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              onClick={handleSubmitSelectedReview}
            >
              SUBMIT SELECTED FOR REVIEW
            </button>
          </div>
        </div>
      </div>

      <div style={{ marginLeft: "40px", paddingTop: "15px" }}>
        <div className="container-RQ-first-90">
          <div className="three-lines-css-RQ">
            <div style={{ color: "#424342" }}>QUESTION TAGGING</div>{" "}
            <div>
              <img
                src={minusImgClose}
                alt=""
                style={{ cursor: "pointer" }}
                onClick={toggleSectionVisibility} // Toggle visibility on click
              />
            </div>
          </div>
        </div>

        <div
          style={{
            display: isSectionVisible ? "block" : "none", // Conditional display based on state
          }}
          className="container-RQ-first-90-2"
        >
          {isOpenTagging && (
            <div className="">
              <div className="grid-container-tagging">
                <div className="grid-item">
                  <AddOptionDropdwon
                    label="Set Name"
                    placeholder={setNameSet} // Correct way to pass the variable dynamically
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedSetName(selectedOption);
                        setSelectedSetId(selectedOption.id); // Update state with the selected ID
                      }
                    }}
                    options={setNames}
                    setOptions={setSetNames}
                    isRequired={true}
                    Height="auto"
                    OverFlow="auto"
                    minheight="300px"
                    disabled={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDown
                    placeholder={selectedCourseLabel || "Select Course"} // Ensure it's actually used
                    label="Course"
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        const selectedCourseObj = coursesdata.find(
                          (course) => course.course_id === selectedOption
                        );

                        setValues((prevValues) => ({
                          ...prevValues,
                          course_id: selectedOption, //  Update course_id state
                        }));

                        setSelectedCourseLabel(
                          selectedCourseObj?.course_description ||
                            "Select Course"
                        ); //  Update selectedCourseLabel
                      } else {
                        // If selection is cleared, retain previous course
                        const initialCourse = coursesdata.find(
                          (course) =>
                            course.course_id ===
                            currentQuestion.course_tag_value_id
                        );

                        setValues({
                          course_id: currentQuestion.course_tag_value_id,
                        });

                        setSelectedCourseLabel(
                          initialCourse?.course_description || "Select Course"
                        ); //  Ensure selectedCourseLabel updates
                      }
                    }}
                    selectedLabel={selectedCourseLabel}
                    options={
                      coursesdata
                        ? coursesdata.map((course) => ({
                            label: course.course_description,
                            id: course.course_id,
                          }))
                        : []
                    }
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP
                    label="Subject"
                    placeholder={selectedSubjectLabel || "Select Subject"} // Show initial value or default placeholder
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedSubject(selectedOption); // Update the selected subject ID

                        console.log(
                          "New Selected Subject Label:",
                          selectedOption.label
                        );
                        setSelectedSubjectLabel(selectedOption.label); // Update the selected subject label
                      }
                    }}
                    selectedLabel={selectedSubjectLabel} // Pass the selected label for display
                    setSelectedLabel={setSelectedSubjectLabel} // Allow dynamic label update
                    options={subjects.map((subject) => ({
                      label: subject.subject_name,
                      id: subject.subject_id,
                    }))} // Subject options
                    isRequired={true}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP
                    label="Chapter"
                    placeholder={selectedChapterLabel || "Select Chapter"} // Show pre-selected value or default
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedChapter(selectedOption); // Update the
                      } else {
                        // If the user clears the selection, reset to defaults
                        setSelectedChapter(
                          currentQuestion.chapter_tag_value_id
                        );
                        setSelectedChapterLabel("Select Chapter");
                      }
                    }}
                    selectedLabel={selectedChapterLabel} // Dynamically display the selected label
                    setSelectedLabel={setSelectedChapterLabel} // Allow updates to the displayed label
                    options={chapters.map((chapter) => ({
                      label: chapter.chapter_name,
                      id: chapter.chapter_id,
                    }))}
                  />
                </div>
                <div className="grid-item">
                  <DropDownUP2
                    label="Topic"
                    placeholder={selectedTopicLabel || "Select Topic"}
                    setSelected={(selectedOption) => {
                      if (selectedOption) {
                        setSelectedTopic(selectedOption);
                      } else {
                        // If the user clears the selection, reset to defaults
                        setSelectedTopic(currentQuestion.topic_tag_value_id);
                        setSelectedChapterLabel("Select Chapter");
                      }
                    }}
                    selectedLabel={selectedTopicLabel}
                    setSelectedLabel={setSelectedTopicLabel}
                    options={topics.map((topic) => ({
                      label: topic.topic_name,
                      id: topic.topic_id,
                    }))}
                  />
                </div>
                {/* Dropdowns */}

                {tags
                  .filter((tag) => tag.parse_tag_type === 1) // Only dropdown-type tags
                  .map((tag) => {
                    // Get the currently selected value from state
                    const selectedValue = dropdownData[tag.parse_tag_id] || "";

                    // Find the corresponding label (if selected)
                    const matchedOption = tag.parse_tag_value.find(
                      (value) => value.parse_tag_value_id === selectedValue
                    );
                    const selectedLabel = matchedOption
                      ? matchedOption.tag_value
                      : `Select ${tag.parse_tag_name}`;

                    return (
                      <div className="grid-item" key={tag.parse_tag_id}>
                        <DropDownMN
                          label={tag.parse_tag_name} // Dynamic label
                          selected={selectedValue} //  Ensure selected value is passed correctly
                          setSelected={(selectedOptionId) => {
                            setDropdownData((prevData) => ({
                              ...prevData,
                              [tag.parse_tag_id]: selectedOptionId, //  Store only ID, not the whole object
                            }));

                            //  Dynamically update label state for specific dropdowns if needed
                            if (tag.tag_id === 8) {
                              setSelectedDifficultyLevelLabel(
                                tag.parse_tag_value.find(
                                  (value) =>
                                    value.parse_tag_value_id ===
                                    selectedOptionId
                                )?.tag_value || "Select Difficulty Level"
                              );
                            }
                          }}
                          options={tag.parse_tag_value.map((value) => ({
                            label: value.tag_value,
                            id: value.parse_tag_value_id,
                          }))} // Dynamic options
                          placeholder={selectedLabel} //  Dynamically update placeholder for each dropdown
                        />
                      </div>
                    );
                  })}
              </div>
              <div className="row-cs-uni">
                {/* Create an array of columns */}
                {[0, 1, 2].map((colIndex) => (
                  <div
                    // className="col-cs-uni-x"
                    style={{
                      // flex: 1, // Make columns take equal space
                      minWidth: "25.9vw", // Ensure minimum width for readability
                    }}
                    key={colIndex}
                  >
                    {tags
                      .filter(
                        (tag, index) =>
                          tag.parse_tag_type === 2 && // Ensure the tag has the correct parse_tag_type
                          tag.parse_tag_id && // Ensure tag has a valid parse_tag_id
                          tag.parse_tag_name && // Ensure tag has a valid parse_tag_name
                          index % 3 === colIndex // Distribute tags evenly across columns
                      )
                      .map((tag) => (
                        <div
                          style={{ marginLeft: "10px" }}
                          key={tag.parse_tag_id}
                        >
                          <div>
                            <input
                              style={{
                                marginRight: "6px",
                                marginTop: "10px",
                              }}
                              className="delete-question-checkbox-dqc"
                              type="checkbox"
                              id={`checkbox-${tag.parse_tag_id}`}
                              checked={!!checkedTags[tag.parse_tag_id]} // Dynamically bind checked state
                              onChange={(e) => {
                                setCheckedTags((prevState) => ({
                                  ...prevState,
                                  [tag.parse_tag_id]: e.target.checked, // Update the tag's checked status
                                }));
                              }}
                            />
                            <label
                              style={{ marginRight: "40px" }}
                              htmlFor={`checkbox-${tag.parse_tag_id}`}
                            >
                              {tag.parse_tag_name}
                            </label>
                          </div>
                        </div>
                      ))}
                  </div>
                ))}
              </div>
              <div className="button-container">
                <button
                  className="simple-review-parser-btn"
                  onClick={applyTagsToAll}
                >
                  Apply to All
                </button>
              </div>
            </div>
          )}
        </div>

        <div style={{ paddingTop: "15px", color: `${Colors.color1}` }}>
          <div className="container-RQ-first-90-3">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                marginBottom: "5px",
                marginRight: "5px",
              }}
            >
              {/* Left Side: Text and Image */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {currentQuestion && (
                  <p style={{ color: "#424342", marginRight: "10px" }}>
                    QUESTION # {currentQuestion.ques_no}
                  </p>
                )}
                <img
                  onClick={handleImageClick}
                  src={isEditMode ? UndoBack : pencil}
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                  alt={isEditMode ? "Undo Changes" : "Edit Question"}
                />
              </div>

              {/* Right Side: Minus Image */}
              <div>
                <img
                  onClick={toggleVisibility}
                  src={minusImgClose}
                  alt="Close"
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
          <div
            ref={questionContainerRef}
            style={{ display: isVisible ? "block" : "none" }}
          >
            <div className="container-RQ-first-90-5">
              <QuestionTypeRadio
                selectedType={questionType}
                onChange={setQuestionType}
              />
            </div>
            {showTwoInputs ? (
              <div className="four-lines-css-RQ">
                <ReviewComponent
                  questionText={currentQuestion?.question_text}
                  optionFromAnotherPage={currentQuestion?.options}
                  quesType={currentQuestion?.ques_type}
                  quesNo={currentQuestion?.ques_no}
                  setCurrentQuestion={setCurrentQuestion}
                  fetchNewUpdatedDataValues={fetchNewUpdatedDataValues}
                  handleReviewAndProceed={handleReviewAndProceed}
                  globalImageCounter={globalImageCounter}
                  setGlobalImageCounter={setGlobalImageCounter}
                  videoUrl={editedVideoLink}
                  setVideoUrl={setEditedVideoLink}
                  explanation={editedSolution}
                  setExplanation={setEditedSolution}
                />
              </div>
            ) : (
              // non-edit mode
              <div
                className="container-RQ-first-90-4"
                style={{
                  paddingRight: "10px",
                  transform: "scale(1)",
                }}
              >
                <div>
                  {currentQuestion &&
                    (() => {
                      // Retrieve local storage data
                      const popData =
                        JSON.parse(localStorage.getItem("POP")) || {};
                      const storedQuestion =
                        popData[currentQuestion.question_id];

                      const displayedQuestion = storedQuestion
                        ? storedQuestion
                        : currentQuestion;
                      const displayedSolution =
                        displayedQuestion.explaination || "";
                      const displayedVideoLink =
                        displayedQuestion.video_url || "";

                      return (
                        <div>
                          <div>
                            <h3
                              className="Qns-RQ-Question"
                              style={{ marginBottom: "1px" }}
                            >
                              Question:
                            </h3>
                            <p
                              className="Qns-RQ-Question-2"
                              dangerouslySetInnerHTML={{
                                __html: processText(
                                  displayedQuestion.question_text
                                ),
                              }}
                            ></p>
                          </div>
                          <ul>
                            {displayedQuestion.options?.map((option, index) => {
                              const isChecked =
                                option.parse_ques_option_correct_flag !==
                                undefined
                                  ? option.parse_ques_option_correct_flag === 1
                                  : option.option_correct_flag === 1; // Fallback for API-fetched questions

                              return (
                                <li
                                  key={index}
                                  className="Qns-RQ-Options"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name={`option-${displayedQuestion.question_id}-${index}`} //  Unique per option
                                    checked={isChecked}
                                    disabled //  Prevents user interaction
                                    style={{
                                      marginRight: "10px",
                                      cursor: "not-allowed",
                                      accentColor: isChecked
                                        ? `${Colors.color11}`
                                        : `${Colors.color4}`,
                                    }}
                                  />
                                  <span
                                    className="Qns-RQ-Options-2"
                                    style={{
                                      // overflowX: "auto",
                                      // maxWidth: "100%",
                                      paddingBottom: "4px",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: processText(option.option_text),
                                    }}
                                  ></span>
                                </li>
                              );
                            })}
                          </ul>

                          {/* {displayedSolution?.trim() !== "" && (
                            <div
                              style={{
                                marginTop: "18px",
                                position: "relative", // <-- Important for absolute child
                              }}
                            >
                              <h3
                                style={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  color: `${Colors.color1}`,
                                  marginBottom: "10px",
                                }}
                              >
                                Solution:
                              </h3>
                              <div
                                className={
                                  isSolutionExpanded
                                    ? ""
                                    : "solution-container-truncated"
                                }
                                style={{
                                  overflowX: "auto",
                                  maxWidth: "100%",
                                  paddingBottom: "4px",
                                  fontSize: "25px",
                                  cursor: "pointer",
                                  transition: "max-height 0.3s ease",
                                  position: "relative", // important for absolute child
                                }}
                                onClick={() => setIsSolutionExpanded(true)}
                                onDoubleClick={() =>
                                  setIsSolutionExpanded(false)
                                }
                              >
                                {isSolutionExpanded ? (
                                  <>
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: processText(displayedSolution),
                                      }}
                                    />
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        color: "#337ab7",
                                        background: "rgba(255,255,255,0.85)",
                                        padding: "2px 10px",
                                        borderRadius: "0 0 0 8px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        zIndex: 2,
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setIsSolutionExpanded(false);
                                      }}
                                    >
                                      ...Less
                                    </span>
                                  </>
                                ) : (
                                  <>
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: processText(
                                          displayedSolution.split("\n")[0]
                                        ),
                                      }}
                                    />
                                    <span
                                      style={{
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        color: "#337ab7",
                                        background: "rgba(255,255,255,0.85)",
                                        padding: "2px 10px",
                                        borderRadius: "0 0 0 8px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        zIndex: 2,
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setIsSolutionExpanded(true);
                                      }}
                                    >
                                      ...More
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          )} */}

                          {/* {(() => {
                            const cleanHTML = processText(displayedSolution);
                            const plainText =
                              new DOMParser().parseFromString(
                                cleanHTML,
                                "text/html"
                              ).body.textContent || "";
                            const truncatedText = plainText.slice(0, 180);

                            if (isSolutionExpanded) {
                              return (
                                <span
                                  style={{
                                    fontSize: "25px",
                                    cursor: "default",
                                  }}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: cleanHTML,
                                    }}
                                  />
                                  <span
                                    onClick={() => setIsSolutionExpanded(false)}
                                    style={{
                                      color: "#337ab7",
                                      marginLeft: "6px",
                                      cursor: "pointer",
                                      fontSize: "16px",
                                    }}
                                  >
                                    ...Show less
                                  </span>
                                </span>
                              );
                            } else {
                              return (
                                <span
                                  style={{
                                    fontSize: "25px",
                                    cursor: "default",
                                  }}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: processText(
                                        truncatedText.trim() + "..."
                                      ),
                                    }}
                                  />
                                  <span
                                    onClick={() => setIsSolutionExpanded(true)}
                                    style={{
                                      color: "#337ab7",
                                      marginLeft: "6px",
                                      cursor: "pointer",
                                      fontSize: "16px",
                                    }}
                                  >
                                   ...Show more
                                  </span>
                                </span>
                              );
                            }
                          })()} */}

                          {/* Solution Header + Expandable Logic */}
                          <div style={{ marginTop: "16px" }}>
                            <h3
                              style={{
                                fontWeight: "600",
                                fontSize: "16px",
                                color: "#424342",
                                marginBottom: "8px",
                              }}
                            >
                              Solution:
                            </h3>
                            {(() => {
                              const fullHTML = processText(displayedSolution);
                              if (isSolutionExpanded) {
                                return (
                                  <span
                                    style={{
                                      fontSize: "25px",
                                      cursor: "default",
                                    }}
                                  >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: fullHTML,
                                      }}
                                    />
                                    <span
                                      onClick={() =>
                                        setIsSolutionExpanded(false)
                                      }
                                      style={{
                                        color: "#337ab7",
                                        marginLeft: "6px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                      }}
                                    >
                                      ...Show less
                                    </span>
                                  </span>
                                );
                              } else {
                                // Truncate the *HTML* (not plain text) for best image/math preview (see previous advice)
                                const truncatedHTML =
                                  fullHTML.slice(0, 80) + "...";
                                return (
                                  <span
                                    style={{
                                      fontSize: "25px",
                                      cursor: "default",
                                    }}
                                  >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: truncatedHTML,
                                      }}
                                    />
                                    <span
                                      onClick={() =>
                                        setIsSolutionExpanded(true)
                                      }
                                      // \( ... \)
                                      style={{
                                        color: `${Colors.color12}`,
                                        marginLeft: "6px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                      }}
                                    >
                                      ...Show more
                                    </span>
                                  </span>
                                );
                              }
                            })()}
                          </div>

                          {displayedVideoLink?.trim() !== "" && (
                            <div style={{ marginTop: "16px" }}>
                              <h3
                                style={{
                                  fontWeight: "600",
                                  fontSize: "16px",
                                  color: `${Colors.color1}`,
                                  marginBottom: "8px",
                                }}
                              >
                                Video Explanation:
                              </h3>
                              <a
                                href="#"
                                style={{
                                  color: `${Colors.color12}`,
                                  textDecoration: "underline",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setModalVideoContent(displayedVideoLink);
                                  setShowVideoModal(true);
                                }}
                              >
                                {displayedVideoLink.includes("<iframe")
                                  ? "View Video"
                                  : displayedVideoLink}
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ width: "81vw", padding: "5px" }}>
          <div style={{ width: "81vw", padding: "5px" }}>
            <div className="row-space-between">
              <div className="flex-gap">
                <div>
                  <button className="grey-submitted-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Submitted
                  </label>
                </div>
                <div>
                  <button className="blue-review-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Reviewed
                  </label>
                </div>
                <div>
                  <button className="White-Not-review-parser width-overwrite"></button>
                  <label className="C6A6A6A" style={{ marginLeft: "5px" }}>
                    Not Reviewed
                  </label>
                </div>
              </div>

              <div className="flex-gap">
                <button
                  onClick={handlePreviousButtonClick}
                  className="simple-review-parser-btn"
                  aria-label="Previous"
                >
                  Previous
                </button>
                <button
                  className="simple-review-parser-btn"
                  onClick={handleDeleteQuestion}
                  disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
                  style={{
                    cursor:
                      currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
                  }}
                  aria-label="Delete / Restore"
                >
                  {currentQuestion &&
                  deletedQuestions.includes(currentQuestion.question_id)
                    ? "Restore"
                    : "Delete"}
                </button>

                <button
                  onClick={handleSkipReview}
                  className="simple-review-parser-btn"
                  disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
                  style={{
                    cursor:
                      currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
                  }}
                  aria-label="Skip Review"
                >
                  Skip Review
                </button>

                <button
                  onClick={handleReviewAndProceed}
                  className="simple-review-parser-btn"
                  disabled={currentQuestion?.status >= 4} // Disable if status is 4 or greater
                  style={{
                    cursor:
                      currentQuestion?.status >= 4 ? "not-allowed" : "pointer", // Change cursor style when disabled
                  }}
                  aria-label="Review and Proceed"
                >
                  Review & Proceed
                </button>
              </div>
            </div>

            <div className="flex-gap width-superseeding Selection-Button-RQ">
              <div className="Selection-Button-RQ">
                {questionsData.map((question) => (
                  <button
                    style={{
                      margin: "3px",
                      opacity: isEditMode ? 0.5 : 1, // Reduce opacity when disabled
                      cursor: isEditMode ? "not-allowed" : "pointer", // Show 'not-allowed' cursor
                    }}
                    className={getButtonClass(question)}
                    key={question.question_id}
                    onClick={() => {
                      if (!isEditMode) {
                        handleButtonClick(question); // Only call if not in edit mode
                      }
                    }}
                    disabled={isEditMode} // Disable button when in edit mode
                  >
                    {question.ques_no}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showVideoModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowVideoModal(false)}
        >
          <div
            style={{
              background: "#fff",
              padding: "24px",
              borderRadius: "8px",
              minWidth: "350px",
              maxWidth: "90vw",
              maxHeight: "80vh",
              boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
              position: "relative",
              width: "900px",
              height: "400px",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "8px",
                right: "12px",
                background: "transparent",
                border: "none",
                fontSize: "22px",
                cursor: "pointer",
              }}
              onClick={() => setShowVideoModal(false)}
              aria-label="Close"
            >
              ×
            </button>
            {modalVideoContent.includes("<iframe") ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                }}
                dangerouslySetInnerHTML={{
                  __html: modalVideoContent
                    .replace(
                      /<iframe([^>]*)style="[^"]*"([^>]*)>/,
                      '<iframe$1style="width:100%;height:100%;border:none;"$2>'
                    )
                    .replace(
                      /<iframe([^>]*)>/,
                      '<iframe$1 style="width:100%;height:100%;border:none;">'
                    ),
                }}
              />
            ) : (
              <a
                href={modalVideoContent}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: Colors.color12,
                  textDecoration: "underline",
                  fontSize: "16px",
                  wordBreak: "break-all",
                }}
              >
                {modalVideoContent}
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewQuestion;
